import { Dispatch } from 'redux';

export const GET_PROFILE_REQUEST = 'PROFILE_GET_PROFILE_REQUEST';
export const GET_PROFILE_RESPONSE = 'PROFILE_GET_PROFILE_RESPONSE';
export const GET_PROFILE_ERROR = 'PROFILE_GET_PROFILE_ERROR';

export const getProfileInfo = (userId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PROFILE_REQUEST,
    });
};



// WEBPACK FOOTER //
// ./src/actions/profile.ts